import { render } from "./claim-profile.vue?vue&type=template&id=154ea4e8&scoped=true"
import script from "./claim-profile.vue?vue&type=script&lang=js"
export * from "./claim-profile.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=154ea4e8&scoped=true&lang=css"
import "./claim-profile.vue?vue&type=style&index=1&id=154ea4e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154ea4e8"]])

export default __exports__